import { render, staticRenderFns } from "./mobilechecklog0512archive-add-or-update.vue?vue&type=template&id=25c3d864&"
import script from "./mobilechecklog0512archive-add-or-update.vue?vue&type=script&lang=js&"
export * from "./mobilechecklog0512archive-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports